const BoxContainer = (props) => {
  return (
    <div className="lettergeneration-container">
      <div className="content-block">{props.children}</div>
    </div>
  );
};

export default BoxContainer;
